module.exports = __webpack_public_path__ + "static/media/logo.5a2e380f.png";